import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import Measure from 'react-measure';
import * as styles from './MiniTabBar.scss';

var MiniTabBar = /*#__PURE__*/function (_Component) {
  _inherits(MiniTabBar, _Component);

  var _super = _createSuper(MiniTabBar);

  function MiniTabBar() {
    var _this;

    _classCallCheck(this, MiniTabBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      containerWidth: 0,
      containerShift: 0
    });

    _defineProperty(_assertThisInitialized(_this), "tabListRef", null);

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e, item) {
      if (item) {
        var totalItemWidth = Object.keys(_this.state).reduce(function (acc, key) {
          return acc + (key.indexOf('width-') === 0 ? _this.state[key] : 0);
        }, 0);

        if (totalItemWidth > _this.state.containerWidth && _this.tabListRef) {
          var target = function () {
            if (e.target.tagName === 'LI') {
              return e.target;
            }

            if (e.target.parentNode.tagName === 'LI') {
              return e.target.parentNode;
            }

            return null;
          }();

          if (target) {
            _this.setState({
              containerShift: target.offsetLeft === 10 ? 0 : -(target.offsetLeft - 100)
            });
          }
        }

        if (_this.props.onChange) {
          // for redux form
          _this.props.onChange(item);
        }

        if (_this.props.onTabClick) {
          _this.props.onTabClick(item);
        }
      }
    });

    return _this;
  }

  _createClass(MiniTabBar, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var tabs = this.props.items.map(function (item, index) {
        var className = item.selected ? "".concat(styles.tab, " ").concat(styles.activetab) : "".concat(styles.tab);
        var activeStyle = item.selected ? {
          borderColor: '#8b8b8b'
        } : {};
        return /*#__PURE__*/React.createElement(Measure, {
          whitelist: ['width'],
          key: index,
          onMeasure: function onMeasure(_ref) {
            var width = _ref.width;

            _this2.setState(_defineProperty({}, "width-".concat(index), width));
          }
        }, /*#__PURE__*/React.createElement("li", {
          className: className,
          onClick: function onClick(e) {
            return _this2.handleClick(e, item);
          },
          style: activeStyle
        }, item.icon ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
          className: "fa ".concat(item.icon)
        }), "\xA0") : item.Render && typeof item.Render === 'function' ? /*#__PURE__*/React.createElement(item.Render, {
          isActive: item.selected
        }) : null, item.title));
      });
      var totalItemWidth = Object.keys(this.state).reduce(function (acc, key) {
        return acc + (key.indexOf('width-') === 0 ? _this2.state[key] : 0);
      }, 0);
      return /*#__PURE__*/React.createElement(Measure, {
        whitelist: ['width'],
        onMeasure: function onMeasure(_ref2) {
          var width = _ref2.width;

          _this2.setState({
            containerWidth: width
          });
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative'
        }
      }, totalItemWidth > this.state.containerWidth && this.props.showScrollNav && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: styles.scrollBack,
        onClick: function onClick() {
          if (Math.abs(_this2.state.containerShift) > 0) {
            _this2.setState({
              containerShift: Math.min(0, _this2.state.containerShift + 100)
            });
          }
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-chevron-left"
      })), /*#__PURE__*/React.createElement("span", {
        className: styles.scrollForward,
        onClick: function onClick() {
          if (Math.abs(_this2.state.containerShift) < totalItemWidth - _this2.state.containerWidth + 200) {
            _this2.setState({
              containerShift: _this2.state.containerShift - 100
            });
          }
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-chevron-right"
      }))), /*#__PURE__*/React.createElement("div", {
        className: styles.wrap,
        style: this.props.style
      }, /*#__PURE__*/React.createElement("ul", {
        ref: function ref(r) {
          return _this2.tabListRef = r;
        },
        className: styles.listWrap,
        style: {
          transform: "translateX(".concat(this.state.containerShift, "px)")
        }
      }, tabs), this.props.children)));
    }
  }]);

  return MiniTabBar;
}(Component);

export { MiniTabBar as default };
MiniTabBar.defaultProps = {
  tabStyle: {},
  style: {},
  showScrollNav: true
};